export const AVATAR_COLORS = [
  'deep-purple lighten-4 deep-purple--text text--accent-4',
  'orange lighten-4 orange--text text--darken-4',
  'green lighten-4 green--text text--darken-2',
  'red lighten-4 red--text text--darken-2',
  'light-blue lighten-4 light-blue--text text--darken-3',
  'pink lighten-4 pink--text text--darken-2',
  'deep-purple lighten-5 deep-purple--text text--darken-1',
]

export const INDIKASI_COLORS = {
  lokasi: 'primary',
  versi: 'deep-purple',
}

export const INDIKASI_LABELS = {
  lokasi: 'Lokasi Presensi Identik',
  versi: 'Versi aplikasi',
}
